const iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;

export function durationToString(iso8601Duration) {
  const matches = iso8601Duration.match(iso8601DurationRegex);

  const completeDuration = {
    sign: matches[1] === undefined ? '+' : '-',
    years: matches[2] === undefined ? 0 : matches[2],
    months: matches[3] === undefined ? 0 : matches[3],
    weeks: matches[4] === undefined ? 0 : matches[4],
    days: matches[5] === undefined ? 0 : matches[5],
    hours: matches[6] === undefined ? 0 : matches[6],
    minutes: matches[7] === undefined ? 0 : matches[7],
    seconds: matches[8] === undefined ? 0 : matches[8],
  };
  let str = completeDuration.years > 0 ? `${completeDuration.years}y` : '';
  str += completeDuration.months > 0 ? `${completeDuration.months}m` : '';
  str += completeDuration.weeks > 0 ? `${completeDuration.weeks}w` : '';
  str += completeDuration.days > 0 ? `${completeDuration.days}d` : '';
  str += completeDuration.hours > 0 ? `${completeDuration.hours}h` : '';
  str += completeDuration.minutes > 0 ? `${completeDuration.minutes}m` : '';
  str += completeDuration.seconds > 0 ? `${completeDuration.seconds}h` : '';
  return str;
}
